// extracted by mini-css-extract-plugin
export var noButton = "SliderSection-module--no-button--9de1f";
export var section = "SliderSection-module--section--b90e4";
export var slider = "SliderSection-module--slider--529fe";
export var title = "SliderSection-module--title--db569";